import { Button } from "antd";
// import "../../assets/styles/banks.css"
// import { Typography } from "antd";
import { Popconfirm } from "antd";
import { Badge } from "antd";
import { ExclamationCircleOutlined,PrinterOutlined,QuestionCircleOutlined,DeleteOutlined } from "@ant-design/icons";
// import { TagProductSpecificationStatus } from "../../components/badge-and-tag/ERP";
import {
  EditableRow,
  EditableCell,
} from "../../components/table/TableEditAble";
import dayjs from "dayjs";
import { formatMoney } from "../../utils/util";
import { TagsCreateBy } from "../../components/badge-and-tag";

import { docLinkRender } from "../../components/table/DocLink";
const calTotalDiscount = (rec) => {
  const total = Number(rec?.qty || 0) * Number(rec?.price || 0);
  const discount = 1 - Number(rec?.discount || 0) / 100;

  return total * discount;
};
/** export component for edit table */
export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};

/** get sample column */
export const accessColumn = ({ handleDelete,handleView, handlePrint }) => [
  {
    title: "PSP Code",
    key: "psp_code",
    dataIndex: "psp_code",
    align: "left",
    sorter: (a, b) => a.psp_code.localeCompare(b.psp_code),
    width:100,
      /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
      render: docLinkRender(handleView, "เปิดดู Product Specification"),
    },
  {
    title: "Product Name",
    key: "spname",
    dataIndex: "spname",
    align: "left",
    sorter: (a, b) => a.spname.localeCompare(b.spname),
  },
  {
    title: "SP code",
    dataIndex: "spcode",
    key: "spcode",
    width: 150,
    sorter: (a, b) => a.spcode.localeCompare(b.spcode),
  },
  {
    title: "Product code",
    dataIndex: "product_code",
    key: "product_code",
    width: 150,
    sorter: (a, b) => a.product_code.localeCompare(b.product_code),
  },
  {
      title: "Customer List",
      dataIndex: "cusresult",
      key: "cusresult", 
      width: 260,
      sorter: (a, b) => (a?.cusresult || "").localeCompare(b?.cusresult || ""),
      render: (v) => ( <div className="sm-name" dangerouslySetInnerHTML={{ __html: v }} ></div> )
    },
  {
    title: "Current Version",
    dataIndex: "version",
    key: "version",
    width: 100,
    sorter: (a, b) => a.version - b.version,
  },
  {
    title: "PSP Date",
    dataIndex: "psp_date",
    key: "psp_date",
    width: 100,
    sorter: (a, b) => a.psp_date.localeCompare(b.psp_date),
    render: (v) => dayjs(v).format("DD/MM/YYYY"),
  },
  {
    title: "จัดทำโดย",
    dataIndex: "created_name",
    key: "created_name",
    sorter: (a, b) => a.created_name.localeCompare(b.created_name),
    width: 140,
    ellipsis: {
      showTitle: false,
    },
    render: (data, role) => <TagsCreateBy result={data} role={role} />,
  },
  {
    title: "ตัวเลือก",
    align: "center",
    key: "operation",
    dataIndex: "operation",
    width: "90px",
    fixed: "right",
    render: (text, record) => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: ".5rem",
            justifyContent: "start",
          }}
        >
          <Badge size="small" offset={[0, 1]}>
            <Button
              icon={<ExclamationCircleOutlined />}
              className="bn-success-outline"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={(e) => handleView(record)}
              size="small"
            />
            
          </Badge>
          <Badge size="small" offset={[0, 1]}><Button 
          icon={<PrinterOutlined />} 
          className='bn-warning-outline'
          style={{ cursor: "pointer", display: 'flex', alignItems: 'center', justifyContent: 'center'}}
          onClick={(e) => handlePrint(record) }
          size="small"
        /></Badge>
        <Popconfirm 
          placement="topRight"
          title="ต้องการลบใช่หรือไม่?"  
          description="ยืนยันการลบ?"
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          onConfirm={() => handleDelete(record)}
        >
        <Button
            icon={<DeleteOutlined />}
            danger
            style={{ cursor: "pointer", display: 'flex', alignItems: 'center', justifyContent: 'center' }} 
            size="small"
          />
        </Popconfirm>
        </div>
      );
    },
  },
];

/** get column for view sample preparation parameter */

export const parameterColumnView = [
  {
    title: "Parameter Name",
    width: 250,
    key: "phy_name",
    dataIndex: "phy_name",
    align: "left",
  },
  {
    title: "Preparation Value",
    align: "left",
    width: 250,
    key: "limit_number",
    dataIndex: "limit_number",
    className: "field-edit",
  },
  {
    title: "Cut Out Value",
    align: "left",
    width: 250,
    key: "cutout",
    dataIndex: "cutout",
    className: "field-edit",
  },
  {
    title: "Range",
    align: "left",
    width: 250,
    key: "physical",
    dataIndex: "physical",
    className: "field-edit",
  },
  {
    title: "Remark",
    align: "left",
    key: "phy_remark",
    dataIndex: "phy_remark",
    className: "field-edit",
  },
];

export const parameterColumnPrint = [
  {
    title: "Parameter Name",
    width: 300,
    key: "phy_name",
    dataIndex: "phy_name",
    align: "left",
  },
  {
    title: "Range",
    align: "left",
    width: 250,
    key: "physical",
    dataIndex: "physical",
    className: "field-edit",
  },
  {
    title: "Remark",
    align: "left",
    key: "phy_remark",
    dataIndex: "phy_remark",
    className:"field-edit",
  },
];

export const parameterMicroColumnPrint = [
  {
    title: "Parameter",
    width: 400,
    key: "micro_name",
    dataIndex: "micro_name",
    align: "left",
  },
  {
    title: "Preparation Value",
    align: "left",
    width: 400,
    key: "limit_number",
    dataIndex: "limit_number",
    className: "field-edit",
  },
  {
    title: "Unit",
    align: "left",
    width: 220,
    key: "unit",
    dataIndex: "unit",
  },
  {
    title: "Remark",
    align: "left",
    key: "remark",
    dataIndex: "remark",
    className:"field-edit",
  },
];

export const parameterMetalColumnPrint = [
  {
    title: "Parameter Name",
    key: "metal_name",
    dataIndex: "metal_name",
    align: "left",
  },
  {
    title: "Limit Number",
    align: "left",
    width: "40%",
    key: "limit_number",
    dataIndex: "limit_number",
  },
];

export const parameterCustomerColumnView = [
  {
    title: "Customer Code",
    key: "cuscode",
    dataIndex: "cuscode",
    width: 180,
    align: "left",
  },
  {
    title: "Customer Name",
    key: "cusname",
    dataIndex: "cusname",
    align: "left",
  },
  {
    title: "Remark",
    align: "left",
    key: "remark",
    width: "30%",
    dataIndex: "remark",
    className: "field-edit",
  },
];

export const parameterMicroColumnView = [
  {
    title: "Parameter Name",
    key: "micro_name",
    dataIndex: "micro_name",
    align: "left",
  },
  {
    title: "Preparation Value",
    align: "left",
    width: 50,
    key: "limit_number",
    dataIndex: "limit_number",
    className: "field-edit",
  },
  {
    title: "Unit",
    align: "left",
    width: 50,
    key: "unit",
    dataIndex: "unit",
  },
  {
    title: "Remark",
    align: "left",
    key: "remark",
    dataIndex: "remark",
    className: "field-edit",
  },
];

export const parameterMetalColumnView = [
    {
      title: "Parameter Name",
      key: "metal_name",
      dataIndex: "metal_name",
      align: "left",
      width: 350,
    },
    {
      title: "Limit Number",
      align: "left",
      width: 220,
      key: "limit_number",
      dataIndex: "limit_number",
      className:"field-edit",
    }
];

export const parameterRemarkColumnView = [
  {
    title: "Remark Name",
    key: "remark_name",
    dataIndex: "remark_name",
    align: "left",
  },
];

/** get column for show data SR Sample request Detail */
export const defaultColumns = ({ handleAction }) => {
  return [
    {
      title: "ลำดับ",
      key: "index",
      align: "left",
      width: 80,
      render: (_, record, idx) => <span key={record?.stcode}>{idx + 1}</span>,
    },
    {
      title: "Code",
      key: "stcode",
      dataIndex: "stcode",
      width: 140,
    },
    {
      title: "ชื่อส่วนผสม",
      key: "stname",
      dataIndex: "stname",
    },
    {
      title: "น้ำหนัก(g)",
      key: "amount",
      dataIndex: "amount",
      editable: true,
      required: true,
      align: "right",
      width: 120,
      className: "field-edit pe-2",
      render: (v) => formatMoney(Number(v || 0)),
    },
    {
      title: "%",
      align: "right",
      width: "6%",
      className: "pe-2",
      key: "percent",
      dataIndex: "percent",
      render: (v) => formatMoney(Number(v || 0) * 100, 2, 2),
    },
    {
      title: "%(total)",
      align: "right",
      width: "6%",
      className: "pe-2",
      key: "totalpercent",
      dataIndex: "totalpercent",
      render: (v, record, idx) =>
        v !== null ? formatMoney(Number(v) * 100, 2, 2) : "",
    },
    {
      title: "Multiply",
      align: "right",
      width: "6%",
      className: "pe-2",
      key: "multiply",
      dataIndex: "multiply",
      render: (v, record, idx) => formatMoney(Number(v || 0)),
    },
    {
      title: "Wt.in process",
      align: "right",
      width: "6%",
      className: "pe-2",
      key: "amount",
      dataIndex: "amount",
      render: (v, record, idx) => {
        const weight_in =
          Number(record?.amount || 0) * Number(record?.multiply || 0);
        return formatMoney(Number(weight_in || 0), 2, 2);
      },
    },
    {
      title: "Yield(%)",
      align: "right",
      width: "6%",
      className: "pe-2",
      key: "yield",
      dataIndex: "yield",
      render: (v, record, idx) => `${formatMoney(Number(v || 0))}%`,
    },
    {
      title: "Rm cost/kg",
      align: "right",
      width: "6%",
      className: "pe-2",
      key: "price",
      dataIndex: "price",
      render: (v, record, idx) => formatMoney(Number(v || 0)),
    },
    {
      title: "Sample cost/kg",
      align: "right",
      width: "6%",
      className: "pe-2",
      key: "cost",
      dataIndex: "cost",
      render: (v, record, idx) => formatMoney(Number(v || 0), 2, 2),
    },
    {
      title: "Method",
      align: "left",
      key: "method",
      dataIndex: "method",
      editable: true,
      required: false,
      // textArea: true,
      className: "field-edit ps-2",
      width: 180,
    },
    {
      title: "ตัวเลือก",
      align: "center",
      key: "operation",
      dataIndex: "operation",
      render: (_, record, idx) => handleAction(record),
      width: "90px",
      fixed: "right",
    },
  ];
};

export const productColumn = ({ handleAction }, optionsItems) => [
  {
    title: "ลำดับ",
    dataIndex: "ind",
    key: "ind",
    align: "center",
    width: 60,
    render: (im, rc, index) => <>{index + 1}</>,
  },
  {
    title: "รหัสสินค้า",
    dataIndex: "stcode",
    key: "stcode",
    width: 140,
    align: "center",
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "stname",
    key: "stname",
    align: "left",
  },
  {
    title: "ชนิดสินค้า",
    dataIndex: "typename",
    key: "typename",
    align: "center",
    width: "10%",
  },
  {
    title: "จำนวนที่รับแล้ว",
    dataIndex: "recamount",
    key: "recamount",
    width: "8%",
    align: "right",
    className: "!pe-3",
  },
  {
    title: "จำนวน",
    dataIndex: "qty",
    key: "qty",
    width: "8%",
    align: "right",
    className: "!pe-3",
    editable: true,
    required: true,
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.qty || 0), 2, 2)}</>,
  },
  {
    title: "ราคาซื้อ",
    dataIndex: "price",
    key: "price",
    width: "8%",
    align: "right",
    className: "!pe-3",
    editable: true,
    required: true,
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.price || 0), 2, 2)}</>,
  },
  {
    title: "หน่วยสินค้า",
    dataIndex: "unit",
    key: "unit",
    align: "right",
    width: "8%",
    editable: true,
    type: "select",
    optionsItems,
    render: (v) => {
      return optionsItems?.find((f) => f.value === v)?.label;
    },
  },
  {
    title: "ส่วนลด(%)",
    dataIndex: "discount",
    key: "discount",
    width: "7%",
    align: "right",
    className: "!pe-3",
    editable: true,
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.discount || 0), 2, 2)}</>,
  },
  {
    title: "ราคารวม",
    dataIndex: "total",
    key: "total",
    width: "8%",
    align: "right",
    className: "!pe-3",
    render: (_, rec) => <>{formatMoney(calTotalDiscount(rec), 2, 2)}</>,
  },
  {
    title: "ตัวเลือก",
    align: "center",
    key: "operation",
    dataIndex: "operation",
    render: (_, record, idx) => handleAction(record),
    width: "80px",
    fixed: "right",
  },
];

export const parameterColumns = ({ handleAction, handleView }) => {
  return [
    // {
    //   title: "No.",
    //   key: "seq",
    //   dataIndex: "seq",
    //   align: "center",
    //   width: 80,
    // },
    {
      title: "Parameter Name",
      key: "phy_name",
      dataIndex: "phy_name",
      align: "left",
      editable: true,
      required: false,
      width: 350,
    },
    {
      title: "Preparation Value",
      align: "left",
      width: 220,
      editable: true,
      required: false,
      key: "limit_number",
      dataIndex: "limit_number",
    },
    {
      title: "Cut Out Value",
      align: "left",
      width: 220,
      editable: true,
      required: false,
      key: "cutout",
      dataIndex: "cutout",
    },
    {
      title: "Range",
      align: "left",
      width: 220,
      editable: true,
      required: false,
      key: "physical",
      dataIndex: "physical",
    },
    {
      title: "Remark",
      align: "left",
      key: "para_remark",
      dataIndex: "phy_remark",
      editable: true,
      required: false,
    },
    {
      title: "ตัวเลือก",
      align: "center",
      key: "operation",
      dataIndex: "operation",
      render: (_, record, idx) => handleAction(record),
      width: "90px",
      fixed: "right",
    },
  ];
};

export const columnsParametersEditable = (handleSave, { handleAction }) => {
  const col = parameterColumns({ handleAction });
  return col.map((col, ind) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        return {
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
          fieldType: !!col?.textArea,
          required: !!col?.required,
          type: col?.type || "input",
          autocompleteOption: col.autocompleteOption,
        };
      },
    };
  });
};
export const cusColumn = ({ handleActionCustomer }) => {
  return [
    {
      title: "Customer Code",
      key: "cuscode",
      dataIndex: "cuscode",
      align: "left",
      width: 220,
       editable: true,
      required: false,
      type: 'modal-select',
      className:"field-edits pe-2"
    },
    {
      title: "Customer Name",
      key: "cusname",
      dataIndex: "cusname",
      editable: true,
      required: false,
      type: 'modal-select',
      align: "left",
      className:"field-edits pe-2"
    },
     {
      title: "Remark",
      align: "left",
      key: "remark",
      dataIndex: "remark",
      editable: true,
      required: false,
      type: "input",
      className: "field-edit",
      width: 300,
    },
    {
      title: "ตัวเลือก",
      align: "center",
      key: "operation",
      dataIndex: "operation",
      render: (_, record, idx) => handleActionCustomer(record),
      width: "90px",
      fixed: "right",
    },
  ];
}

export const columnsCustomParametersEditable = (handleSave, handleModalSelect, {handleActionCustomer} ) =>{
    const col = cusColumn({handleActionCustomer});
    return col.map((col) => {
        if (!col.editable) { return col; }
        return {
            ...col,
            onCell: (record) => {
              // console.log(record);
              return {
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
                fieldType: !!col?.textArea,
                required: !!col?.required,
                type: col?.type || 'input',
                modalSelect: handleModalSelect
              }
            },
        };
    }); 
}  

export const parameterMicroColumns = () => {
  return [
    {
      title: "Micro Name",
      key: "micro_name",
      dataIndex: "micro_name",
      align: "left",
      width: 280,
    },
    {
      title: "Preparation Value",
      align: "left",
      width: 220,
      key: "limit_number",
      dataIndex: "limit_number",
    },
    {
      title: "Unit",
      align: "left",
      width: 220,
      key: "unit",
      dataIndex: "unit",
    },
    {
      title: "Remark",
      align: "left",
      key: "remark",
      dataIndex: "remark",
    },
  ];
};

export const columnMetal = [
  {
    title: "Parameter Name",
    key: "metal_name",
    dataIndex: "metal_name",
    align: "left",
  },
  {
    title: "Limit Number",
    align: "left",
    width: "40%",
    key: "limit_number",
    dataIndex: "limit_number",
  },
];

export const parameterTreatmentColumns = ({ handleAction }) => {
  return [
    {
      title: "Parameter Name",
      key: "paraname",
      dataIndex: "paraname",
      align: "left",
      width: 280,
    },
    {
      title: "Preparation Value",
      align: "left",
      width: 220,
      key: "preparation",
      dataIndex: "preparation",
    },
    // {
    //   title: "Cut Out Value",
    //   align: "left",
    //   width: 220,
    //   editable: true,
    //   required: false,
    //   key: "cutout",
    //   dataIndex: "cutout",
    //   className:"field-edit",
    //   type:'input',
    // },
    {
      title: "Remark",
      align: "left",
      key: "remark",
      dataIndex: "remark",
    },
  ];
};

export const columnsMicroParametersEditable = (handleSave) => {
  const col = parameterMicroColumns();
  return col.map((col, ind) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        return {
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
          fieldType: !!col?.textArea,
          required: !!col?.required,
          type: col?.type || "input",
          autocompleteOption: col.autocompleteOption,
        };
      },
    };
  });
};

export const columnsTreatmentParametersEditable = (
  handleSave,
  { handleAction }
) => {
  const col = parameterTreatmentColumns({ handleAction });
  return col.map((col, ind) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        return {
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
          fieldType: !!col?.textArea,
          required: !!col?.required,
          type: col?.type || "input",
          autocompleteOption: col.autocompleteOption,
        };
      },
    };
  });
};

export const productspecificationForm = {
  psp_code: null,
  psp_date: null,
};

export const defaultParamenter = [
  {
    seq: 1,
    phy_name: "pH",
    limit_number: "4.5 - 4.9",
    cutout: "n/a",
    remark: null,
  },
  {
    seq: 2,
    phy_name: "Brix",
    limit_number: "27 - 33",
    cutout: "n/a",
    remark: null,
  },
  {
    seq: 3,
    phy_name: "%Salt",
    limit_number: "8.5 - 11.0",
    cutout: "n/a",
    remark: null,
  },
  {
    seq: 4,
    phy_name: "Net weight",
    limit_number: "300ml / 330g",
    cutout: "n/a",
    remark: null,
  },
  {
    seq: 5,
    phy_name: "(followed AQS System)",
    limit_number: "700ml / 810g",
    cutout: "n/a",
    remark: null,
  },
];
export const defaultParamenterMicro = [
  {
    seq: 1,
    micro_name: "Total Plate Count",
    limit_number: "<1000",
    unit: null,
    remark: null,
  },
  {
    seq: 2,
    micro_name: "Yeast & Mold",
    limit_number: "<100",
    unit: null,
    remark: null,
  },
  {
    seq: 3,
    micro_name: "%Coliforms",
    limit_number: "<3.0",
    unit: null,
    remark: null,
  },
];
export const defaultParamenterMetal = [
  {
    seq: 1,
    metal_name: "Lead (Pb)",
    limit_number: "< 1.0 ppm",
    remark: null,
  },
  {
    seq: 2,
    metal_name: "Arsenic (As)",
    limit_number: "< 2.0 ppm",
    remark: null,
  },
  {
    seq: 3,
    metal_name: "Mercury (Hg)",
    limit_number: "< 0.02 ppm",
    remark: null,
  },
  {
    seq: 4,
    metal_name: "Cadmium (Cd)",
    limit_number: "≤ 0.2 ppm",
    remark: null,
  },
];

export const defaultParamenterRemark = [
  {
    seq: 1,
    remark_name:
      "This product complies with Remark standards, but requires formal certification for the use of Remark logo from the Central Islamic Committee of Thailand",
    remark: null,
  },
  {
    seq: 2,
    remark_name: "This product don't complies with Remark standard",
    remark: null,
  },
];

export const collapseSetting = (type, active, items, option = {}) => ({
  collapsible: type,
  defaultActiveKey: active,
  items: items,
  ...option,
});

export const allergenStandardsDefault = [
  {
    value:
      "May contains tree nut, peanut, milk, crustaceans, molluscs, fish and sesame",
  },
  { value: "According to CODEX STAN 1-1985, REGULATION (EU) No 1169/2011" },
  { value: "According to CODEX STAN 1-1985, NHFPC GB 7718-2011" },
  {
    value:
      "According to MFDS : Food Labelling Standards (Notification No. 2019-97, 2019.10.28)",
  },
  {
    value:
      "According to Food Allergen Labeling and Consumer Protection Act of 2004 (Public Law 108-282, Title II)",
  },
  { value: "According to CODEX STAN 1-1985, Japan (CAA, 2019)" },
  {
    value: "According to CODEX STAN 1-1985, According to FSANZ:Standard 1.2.3",
  },
  {
    value:
      "According to CODEX STAN 1-1985, SFA 2019 Ingredients Hypersensitivity",
  },
  {
    value:
      "According to CODEX STAN 1-1985, MOPH (Thailand) No. 367/2557 Labeling of  Prepackaged Foods",
  },
  { value: "Ministry of Public Health Announcement (No.450) B.E.2567(2024)" },
];

export const initialSteps = [
  { title: "Step 1", description: "รายละเอียดขั้นตอนที่ 1", editable: true },
  { title: "Step 2", description: "รายละเอียดขั้นตอนที่ 2", editable: true },
  { title: "Step 3", description: "รายละเอียดขั้นตอนที่ 3", editable: true },
];

export const gmoConditions = [
  {
    value:
      "This product is produced or derived from ingredients supplied from non-GM sources.",
  },
];

export const halalConditions = [
  {
    value:
      "This product complies with Halal standards, but requires formal certification for the use of Halal logo from the Central Islamic Committee of Thailand",
  },
  { value: "This product don't complies with Halal standard" },
  { value: "This product complies with Halal Standard from CICOT" },
];

export const opStorageConditions = [
  {
    value:
      "Storage at ambient temperatue ( not over 35 deg C) and avoid sunlight.",
  },
];

export const opMicroDescription = [
  {
    value:
      "Ministry of Public Health Standard (Thailand) Issue No. 355/2556 (2013) & Issue No.416/2563 (2020) ",
  },
  {
      value:"* COA by internal lab, ** anual test external lab by group products, Ministry of Public Health Standard (Thailand) Issue No. 355/2556 (2013) & Issue No.416/2563 (2020) ",
  },
];

export const opMetalDescription = [
  {
    value: "Ministry of Public Health Standard (Thailand) Issue No. 355/2556 (2013)",
  },
  {
    value: "anual test external lab by group products, Ministry of Public Health Standard (Thailand) Issue No. 355/2556 (2013)",
  },
];
